<template>
  <div class="offers-item">
    <div class="desktop-offer-item">
      <!-- <div class="id"></div> -->
      <div class="amount">{{ item.loan_amount / 100 }}</div>
      <div class="term">{{ item.loan_term_days + "д." }}</div>
      <div class="percent">{{ item.annual_percent }}</div>
      <div class="income">
        {{ (item.loan_amount + item.expected_income) / 100 }}
      </div>
      <div class="rating">{{ item.borrower_min_rating }}</div>
      <div class="count">{{ item.loan_max_count }}</div>
      <div class="status">
        <div :class="`${item.status}-status`">
          {{ $t(`message.profile.lender.activeOffers.published.${item.status}`) }}
        </div>
      </div>
      <div class="menu" v-click-outside="hideOfferMenu">
        <img
          @click="offerMenuToggle()"
          class="offer-menu-img"
          src="../../../public/custom/images/offer-menu.svg"
          alt="Offer menu image"
          v-if="item.status !== 'blocked'"
        />
        <div @click="changeStatus()" class="offer-menu" v-if="isOfferMenuOpen">
          {{
            $t(
              `message.profile.lender.offer.${
                item.status === "published" ? "unpublish" : "publish"
              }`
            )
          }}
        </div>
      </div>
    </div>
    
    <div class="mobile-offer-item">
      <div class="top-line"></div>
      <div class="preview-block" :class="{'full-desc': isFullDesc}" @click.stop="descToggle()">
        <div class="mobile-id">{{ 'ID: ' + item.public_id }}</div>
        <div class="mobile-amount">
          <div class="title">{{ $t('message.profile.lender.activeOffers.items.amount') }}</div>
          <div class="data">{{ item.loan_amount / 100 }}</div>
        </div>
        <div class="mobile-percent">
          <div class="title">{{ $t('message.profile.lender.activeOffers.items.percent') }}</div>
          <div class="data">{{ item.annual_percent }}</div>
        </div>
        <div class="mobile-term">
          <div class="title">{{ $t('message.profile.lender.activeOffers.items.term') }}</div>
          <div class="data">{{ item.loan_term_days + "д." }}</div>
        </div>
        <div class="mobile-status">
          <div class="title">{{ $t('message.profile.lender.activeOffers.items.status') }}</div>
          <div :class="`${item.status}-status`">
            {{ $t(`message.profile.lender.activeOffers.published.${item.status}`) }}
          </div>
        </div>
        <div class="mobile-income">
          <div class="title">{{ $t('message.profile.lender.activeOffers.items.income') }}</div>
          <div class="data">{{ (item.loan_amount + item.expected_income) / 100 }}</div>
        </div>
        <div class="mobile-rating">
          <div class="title">{{ $t('message.profile.lender.activeOffers.items.rating') }}</div>
          <div class="data">{{ item.borrower_min_rating }}</div>
        </div>
        <div class="mobile-count">
          <div class="title">{{ $t('message.profile.lender.activeOffers.items.count') }}</div>
          <div class="data">{{ item.loan_max_count }}</div>
        </div>
        <div class="btn-block">
          <base-button
            :text="$t(`message.profile.lender.activeOffers.publishBtn.${item.status}`)"
            class="transactions-btn"
            @click="changeStatus()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
  name: "landerOfferItem",
  props: {
    item: Object,
  },
  directives: {
    ClickOutside
  },
  data() {
    return {
      isOfferMenuOpen: false,
      isFullDesc: false
    };
  },
  methods: {
    descToggle() {
      this.isFullDesc = !this.isFullDesc;
    },
    offerMenuToggle() {
      this.isOfferMenuOpen = !this.isOfferMenuOpen;
    },
    hideOfferMenu() {
      this.isOfferMenuOpen = false;
    },
    changeStatus() {
      const status = this.item.status === 'published' ? 'not_published' : 'published';
      const public_id = this.item.public_id;

      this.$emit('changeOfferStatus', { status, public_id });
      this.hideOfferMenu();
    }
  }
};
</script>

<style lang="scss" scoped>
.offers-item {
  width: 100%;
}

.desktop-offer-item {
  width: 100%;
  padding: 20px 0 20px 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eceef0;
  font-weight: 400;
  font-size: 18px;
  line-height: 135%;
  color: #121212;
}

.mobile-offer-item {
  width: 100%;
  padding-bottom: 10px;
  box-sizing: border-box;
  display: none;
  flex-direction: column;
  font-size: 16px;
  line-height: 135%;
  font-weight: 400;
  color: #121212;
}

.id {
  width: 11%;
  margin-right: 2%;
  @include overflow-elipsis;
}

.amount {
  width: 10%;
  margin-right: 2%;
}

.term {
  width: 11%;
  margin-right: 2%;
}

.percent {
  width: 10%;
  margin-right: 2%;
}

.income {
  width: 9%;
  margin-right: 2%;
}

.rating {
  width: 7%;
  margin-right: 2%;
}

.count {
  width: 10%;
  margin-right: 2%;
}

.status {
  width: 10%;
  margin-right: 2%;

  div {
    width: fit-content;
    white-space: nowrap;
  }
}

.menu {
  width: 6%;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.published-status {
  width: 48px;
  padding: 8px 15px;
  box-sizing: border-box;
  background: #d6f9d3;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  color: #21a25c;
}

.unpublished-status,
.not_published-status,
.blocked-status {
  width: 55px;
  padding: 8px 15px;
  box-sizing: border-box;
  background: #ffdbdb;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  color: #c93434;
}

.offer-menu-img {
  margin-right: 21px;
  height: 22px;
  width: 22px;
  cursor: pointer;
}

.offer-menu {
  padding: 10px 15px;
  box-sizing: border-box;
  position: absolute;
  top: -43px;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  border: 1px solid #cdcdcd;
  border-radius: 10px;
  font-size: 16px;
  line-height: 135%;
  color: #333333;
  white-space: nowrap;
  cursor: pointer;
}

.top-line {
  margin-bottom: 10px;
  width: 100%;
  height: 1px;
  background: #ECEEF0;
  border-radius: 3px;
}

.preview-block {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 160px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.full-desc {
  height: auto;
}

.mobile-id {
  width: 100%;
  margin-bottom: 10px;
}

.mobile-amount,
.mobile-term,
.mobile-percent,
.mobile-income,
.mobile-status,
.mobile-issued,
.mobile-issued-by,
.mobile-peni,
.mobile-total-amount,
.mobile-rating,
.mobile-count {
  margin-bottom: 8px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.title {
  font-size: 14px;
  line-height: 19px;
  color: #878787;
}

.mobile-status div:last-of-type {
  font-size: 14px;
}

.btn-block {
  margin-top: 20px;
  width: 100%;
  height: 38px;
}

.publish-btn ::v-deep {
  border-radius: 6px;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
}

@media screen and (max-width: 850px) {
  .desktop-offer-item {
    display: none;
  }

  .mobile-offer-item {
    display: flex;
  }
}
</style>
